/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 11:44:25
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/hotAd.tsx
 */
import { Vue, Component, Watch, Prop, Inject } from 'vue-property-decorator';
import style from './style.vue';
import AdContent from './adContent';
import { numberToArray } from '@/util';
import { defaultImg } from '@/views/components/newDisplayConfig/shop';

@Component({
  components: { AdContent },
  mixins: [style],
})
export default class HotAd extends Vue {
  @Prop({ default: () => {} })
    value: DisplayHotAdData;

  @Prop()
    disabled: boolean;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Inject({ default: 0 })
    mode: number;

  @Prop({ default: false })
    classAd: boolean;
  // @Inject()
  // isMoreSite: number;

  @Prop({ default: () => [] })
    attrButeList: ItemArray;

  data: DisplayHotAdData = {};

  maxPage: number[] = numberToArray(20);

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      console.log('hotAd', n)
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  hotUserChange(v) {
    v === 0
      && this.$confirm('选择不使用hot页广告位时，已配置到该广告位上的广告均将失效，请谨慎操作！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(
        (res) => {
          if (res !== 'confirm') {
            this.data.hotAdvert = 1;
          }
        },
        () => {
          this.data.hotAdvert = 1;
        },
      );
  }

  // 添加广告
  onAddAd() {
    this.data.desc.list.push({
      advPic: '',
      advTitle: '',
      advLinkType: 1,
      linkList: [],
      // receiptConfig: {
      //   type: 0,
      //   id: ''
      // },
      // _condition: {
      //   id: '',
      //   text: ''
      // }
    });
  }

  // 网点组HOT页广告 配置
  renderSgHotAdConfig(h) {
    return (
      <div>
        <el-form-item label="广告位名称" prop="pName" rules={[{ required: true, message: ' ', trigger: 'change' }]}>
          <el-input v-model={this.data.desc.pName} class="sm-input" />
        </el-form-item>
        <el-form-item label="广告位尺寸" prop="pHeight" rules={[{ required: true, message: ' ', trigger: 'change' }]}>
          <p>
            <el-input value={this.data.desc.pWidth} disabled class="ssm-input wid-35 r-ml-0" />
            PX *
            <el-input-number style="width:70px" class="ssm-input" v-model={this.data.desc.pHeight} controls={false} max={2000} min={80} precision={0} />
            PX
          </p>
          <p class="tip blockTip">注：&nbsp;该尺寸将在在配置广告内容时进行展示</p>
        </el-form-item>
        <el-form-item label="广告最大页数" class="el-form-item-margin0">
          <el-select v-model={this.data.desc.pMaxPage} class="wid-35">
            {this.maxPage.map((i) => {
              return (
                <el-option label={i} value={i}>
                  {i}
                </el-option>
              );
            })}
          </el-select>
          &nbsp;&nbsp;页
        </el-form-item>
        <el-form-item label="">
          <p class="tip blockTip">注：广告最大页数限制了在小程序前端最多展示的广告页数量</p>
        </el-form-item>
      </div>
    );
  }

  render(h) {
    return (
      <div class="hotAd-edit">
        {this.mode === 1 && (
          <el-radio-group v-model={this.data.hotAdvert} class="r-mb-12" onChange={v => this.hotUserChange(v)} disabled={this.disabled}>
            <el-radio label={1}>使用</el-radio>
            <el-radio label={0}>不使用</el-radio>
          </el-radio-group>
        )}
        {this.data.hotAdvert === 1 && (
          <el-form props={{ model: this.data.desc }} ref="form" label-width="110px" label-position="left" show-message={false} disabled={this.disabled}>
            {this.mode === 1 && this.renderSgHotAdConfig(h)}
            {this.mode === 2 && !this.classAd && (
              <div>
                <p class="title">图片列表(拖动可排序)</p>
                <p class="tip blockTip r-mb-8">请保持图片的分辨率一致，建议为750*600，大小不超过1M。</p>
              </div>
            )}
            {this.mode === 2 && this.classAd && (
              <div>
                <p class="title">分类广告图片(拖动可排序)</p>
                <p class="tip blockTip r-mb-8">请保持图片的分辨率一致，建议为500*150，大小不超过1M。</p>
              </div>
            )}
            {this.mode === 2 && <AdContent v-model={this.data.desc.list} classAd={this.classAd} attrButeList={this.attrButeList} onAddAd={this.onAddAd.bind(this)} pSize={600} />}
          </el-form>
        )}
      </div>
    );
  }
}
